import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';

import App from 'App';
import appReducer from 'pages';
import { routerMiddleware } from 'connected-react-router';
import { history } from 'common/modules/app/router';

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(ReduxThunk, routerMiddleware(history)))
);

/**
 * ReduxのStoreの登録を行うComponent
 */
const Root: React.FC = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

export default Root;
